var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-PB"},[_c('iframe',{attrs:{"title":"Movimiento Diario - Manual de uso","width":"100%","height":"100%","src":"https://app.powerbi.com/view?r=eyJrIjoiMGJjN2NjNjktMTdiZS00YTBmLWI2MzctMzM4MDQ5ZmNlNGE2IiwidCI6IjllMDQ0ZjE3LWM3M2MtNGU1ZC04NWViLTMyNDNlNTU1YjczOSIsImMiOjR9","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }